export const  addTargetBlank=(html)=> {
  const pattern = /(<a\s(?![^>]*\btarget=)(.*?))>/gi

  const replacement = '$1 target="_blank">'

  const newHtml = html&&html.replace(pattern, replacement)
  return newHtml
}
